import { gql } from '@apollo/client';

export const FETCH_CUSTODIAN_ACTIVITIES_QUERY = (permissions: string[]) => `query fetchCustodianActivities($input: FetchCustodianActivitiesInput!) {
  fetchCustodianActivities(input: $input) {
    custodianActivities {
      id
      transactionId
      subTransactionId
      transactionType
      transactionDesc
      quantity
      currency
      commission
      priceCents
      accruedInterest
      amountValueCents
      securityType
      processDate
      effectiveDate
      settleDate
      symbol
      state
      custodianAccountNumber
      clientName
      cusip
      account {
        id
        type
        custodianAccountNumber
        user {
          id
          ${permissions.includes('read:client_low_risk_pii') ? 'firstName' : ''}
          ${permissions.includes('read:client_low_risk_pii') ? 'lastName' : ''}
        }
        organization { id }
      }
      financialProduct {
        ticker
        currency
        translatedName { en }
      }
    }
    totalCount
  }
}`;

export const FETCH_CUSTODIAN_ACTIVITIES = (permissions: string[]) => gql`${FETCH_CUSTODIAN_ACTIVITIES_QUERY(permissions)}`;

export const RECONCILE_CUSTODIAN_ACTIVITY = gql`
  mutation reconcileCustodianActivity($custodianActivityId: ObjectID!) {
    reconcileCustodianActivity(custodianActivityId: $custodianActivityId) {
      custodianActivity {
        id
      }
    }
  }
`;

export const FORCE_RECONCILE_CUSTODIAN_ACTIVITY = gql`
  mutation forceReconcileCustodianActivity($custodianActivityId: ObjectID!) {
    forceReconcileCustodianActivity(custodianActivityId: $custodianActivityId) {
      custodianActivity {
        id
      }
    }
  }
`;
